module.exports = __webpack_public_path__ + "img/Konachan.com-293553.a785ff07.jpg";